import { useState, useEffect } from 'react'
import Navbar from '../Components/Navbar'
import HashLoader from "react-spinners/HashLoader";
import Footer from '../Components/Footer';
import bg from '../images/bg.png'
import bgtwo from '../images/bg2.png'
import CarouselLogo from '../Components/CarouselLogo'
import Reviews from '../Components/Reviews';
import Haboutus from '../Components/Haboutus';

export default function Home() {
  


    const [loading, setLoading] = useState(false)
    useEffect(() => {
      setLoading(true)
      setTimeout(() =>{
        setLoading(false)
      }, 3500)
    }, [])
  
  return (
  <>
    {
        loading ?
        <div className="loader">
        <HashLoader color="#36d7b7" /> </div>
        
        :
        
   <></>
    }


     <div>
      <><Navbar/>
      <div className='bg ' style = {{
        backgroundImage:
        `url(${bg})`,
        
     }}>
    <section className='bg-gray-800/50 h-full'>
      <div className='text-white text-4xl lg:text-6xl text-center yo relative top-32 ' >
      <h1>Where every journey begins with</h1>
      
      <h1>reliability...</h1>
      
      </div>
      <div class="flex justify-center mt-12 xl:mt-0">
      <a href="/askrate" class="relative top-40 mx-auto  inline-flex items-center px-6 py-3 overflow-hidden font-medium transition-all bg-white rounded hover:bg-white group">
<span class="w-48 h-48 rounded rotate-[-40deg] bg-purple-600 absolute bottom-0 left-0 -translate-x-full ease-out duration-500 transition-all translate-y-full mb-9 ml-9 group-hover:ml-0 group-hover:mb-32 group-hover:translate-x-0"></span>
<span class="relative w-full text-left text-black transition-colors duration-300 ease-in-out group-hover:text-white">Know More!</span>
</a>
</div>
<div className=' hidden xl:block'>
<div className='flex grid grid-cols-2 xl:grid-cols-4 px-auto justify-items-center items-center  mt-96 xl:mt-48'>
<div className="  min-w-24 xl:min-w-64	 h-32 bg-white shadow-2xl rounded-md  border-2 border-transparent hover:border-purple-800  transition duration-300 ease-in-out">
<div className=' justify-center items-center flex'><svg className='max-w-24  ' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" id="handshake"><g fill="darkblue"><path d="M10.17 38a1.007 1.007 0 0 1-.458-.11L2.09 33.964a1 1 0 0 1-.434-1.342l8.954-17.686a1 1 0 0 1 1.347-.439l7.251 3.7a1 1 0 0 1 .448 1.324l-8.584 17.908a1.006 1.006 0 0 1-.583.516 1.028 1.028 0 0 1-.319.055Zm-6.281-5.36 5.824 3 7.718-16.1-5.49-2.8Z"></path><path d="M20.53 24.084a1 1 0 0 1-.491-.129l-2.906-1.637a1 1 0 1 1 .981-1.743l2.4 1.351c.937-.568 2.965-1.791 4.263-2.524 2.119-1.2 3.611-1.035 5.324.588a1 1 0 0 1-1.375 1.452c-1.064-1.008-1.618-1.06-2.965-.3-1.668.943-4.677 2.777-4.708 2.8a1 1 0 0 1-.523.142Z"></path><path d="M46.837 41.483a3.827 3.827 0 0 1-2.072-.547c-.92-.614-4.968-4.584-5.77-5.373a1 1 0 0 1 1.4-1.426c1.8 1.777 4.888 4.742 5.477 5.135a2.328 2.328 0 0 0 2.364-.244 1.422 1.422 0 0 0-.04-2.182c-1.022-1.15-5.268-5.235-6.2-6.131a66.293 66.293 0 0 1-9.432-4.322l-1.052.688a4.582 4.582 0 0 1-1.771 2.731 2.759 2.759 0 0 1-2.278.532 3.475 3.475 0 0 1-2.409-1.444 4.74 4.74 0 0 1-.166-3.617c.853-3.414 2.237-4.293 4.152-5.509l.421-.269c2.11-1.355 3.921-2.077 5.909-1.182 1.236.557 5.623 2.256 6.869 2.738l4.176-1.369a1 1 0 0 1 .623 1.9l-4.515 1.48a1.007 1.007 0 0 1-.67-.016c-.237-.092-5.815-2.238-7.3-2.908-.891-.4-1.832-.359-4.008 1.039l-.43.275c-1.747 1.109-2.624 1.667-3.284 4.306-.338 1.352-.182 1.9-.059 2.1.158.264.524.371 1.107.517a.856.856 0 0 0 .706-.2A2.587 2.587 0 0 0 29.6 26.4a1 1 0 0 1 .448-.75l1.925-1.259A1 1 0 0 1 33 24.353c.068.037 6.81 3.724 9.763 4.5a1.018 1.018 0 0 1 .438.245c.216.207 5.3 5.075 6.494 6.422a3.4 3.4 0 0 1-.04 4.924 4.013 4.013 0 0 1-2.818 1.039Z"></path><path d="M48.947 37.182a1 1 0 0 1-.405-1.914l3.508-1.554a1 1 0 1 1 .81 1.828L49.351 37.1a1 1 0 0 1-.404.082Z"></path><path d="M53.534 38a1 1 0 0 1-.927-.626l-7.548-18.726a1 1 0 0 1 .59-1.316l8.066-2.886a1 1 0 0 1 1.266.572l7.4 18.574a1 1 0 0 1-.571 1.3l-7.918 3.038a1 1 0 0 1-.358.07zM47.3 18.864l6.791 16.847 6.054-2.32-6.665-16.737zm-4.968 25.652a3.386 3.386 0 0 1-2.264-.779c-1.339-1.19-4.781-4.63-4.927-4.776a1 1 0 0 1 1.414-1.414c.035.035 3.547 3.545 4.841 4.7a1.951 1.951 0 0 0 1.8.12A2.709 2.709 0 0 0 45 40.208a1 1 0 0 1 1.971.34 4.712 4.712 0 0 1-3.11 3.7 4.654 4.654 0 0 1-1.529.268z"></path><path d="M37.678 46.94a3.164 3.164 0 0 1-2.241-.8l-3.552-3.552 1.415-1.415 3.552 3.552a1.8 1.8 0 0 0 1.457.136 2.636 2.636 0 0 0 1.918-1.879 1 1 0 1 1 1.912.586 4.657 4.657 0 0 1-4.46 3.372Z"></path><path d="M33.866 49.611a3.632 3.632 0 0 1-2.269-.735 298.882 298.882 0 0 0-2.715-2.148 1 1 0 1 1 1.231-1.576s1.249.975 2.734 2.163a2.127 2.127 0 0 0 2.1.043 1.559 1.559 0 0 0 .942-1.493 1 1 0 0 1 .969-1.03 1.013 1.013 0 0 1 1.03.97 3.558 3.558 0 0 1-2.048 3.343 4.461 4.461 0 0 1-1.974.463Z"></path><path d="M26.372 49.148a2.5 2.5 0 0 1-.947-.19A4.416 4.416 0 0 1 23.5 47.12a3.151 3.151 0 0 1-2.083-.313 4.825 4.825 0 0 1-2.086-3.088 1 1 0 0 1 .137-.741c.813-1.268 2.039-3.239 2.222-3.65A2.546 2.546 0 0 1 23.35 38a3.358 3.358 0 0 1 2.842.544 2.98 2.98 0 0 1 1.324 2.742 3.329 3.329 0 0 1 2.46 1.251 3.59 3.59 0 0 1 .383 3.067 5.949 5.949 0 0 1-3 3.344 2.534 2.534 0 0 1-.987.2Zm-1.188-3.121c.314.531.875 1.293 1.4 1.074a3.949 3.949 0 0 0 1.882-2.139 1.621 1.621 0 0 0-.1-1.247 1.585 1.585 0 0 0-1.154-.452Zm-3.791-2.35a2.526 2.526 0 0 0 .977 1.372 1.214 1.214 0 0 0 .963.063l2.135-3.66a1.065 1.065 0 0 0-.412-1.264 1.4 1.4 0 0 0-1.1-.281.751.751 0 0 0-.44.243c-.264.585-1.534 2.601-2.123 3.527Z"></path><path d="M18.729 45.239a2.451 2.451 0 0 1-.7-.1c-1.713-.515-2.384-2.733-2.455-2.984a1 1 0 0 1 .093-.765 41.481 41.481 0 0 1 2.815-4.26 3.394 3.394 0 0 1 4.494-.807c.944.655 1.636 2.08.478 3.942a1 1 0 1 1-1.7-1.055c.257-.415.48-.966.081-1.243a1.384 1.384 0 0 0-1.769.382 39.431 39.431 0 0 0-2.435 3.64c.219.523.592 1.122.973 1.235.337.1.8-.246 1.051-.46a1 1 0 0 1 1.308 1.514 3.41 3.41 0 0 1-2.234.961Z"></path><path d="M16.534 42.88a1 1 0 0 1-.323-.054c-.169-.057-4.155-1.45-4.155-4.572a1.012 1.012 0 0 1 .048-.309 11.688 11.688 0 0 1 1.473-2.8 3.105 3.105 0 0 1 3.848-.744 2.589 2.589 0 0 1 1.4 3.207c-.654 2.106-1.325 4.513-1.332 4.538a1 1 0 0 1-.963.731Zm-2.47-4.471c.1.936 1.058 1.648 1.826 2.075.261-.912.648-2.239 1.028-3.466a.6.6 0 0 0-.376-.82 1.2 1.2 0 0 0-1.329.1 10.356 10.356 0 0 0-1.149 2.111Z"></path><path d="M13.877 37.529a1 1 0 0 1-.564-.175l-2.623-1.8a1 1 0 0 1 1.13-1.651l2.623 1.8a1 1 0 0 1-.566 1.826Z"></path></g></svg></div>
     <h1 className='text-2xl relative bottom-4   yo2 text-center text-amber-600'>TRUST</h1>
</div>
<div className=" min-w-24 xl:min-w-64 h-32 bg-white shadow-2xl rounded-md  border-2 border-transparent hover:border-purple-800  transition duration-300 ease-in-out">
<div className=' justify-center items-center flex pt-2'><img src="./images/trans.png" alt="" /></div>
     <h1 className='text-2xl pt-4   yo2 text-center text-amber-600'>TRANSPARENCY</h1>
</div>
<div className=" min-w-24 xl:min-w-64	 h-32 bg-white shadow-2xl rounded-md  border-2 border-transparent hover:border-purple-800  transition duration-300 ease-in-out">
<div className=' justify-center items-center flex pt-2'><img src="./images/inte.png" alt="" /></div>
     <h1 className='text-2xl pt-4  yo2 text-center text-amber-600'>INTEGRITY</h1>
</div>
<div className="  min-w-24 xl:min-w-64	 h-32 bg-white shadow-2xl rounded-md  border-2 border-transparent hover:border-purple-800  transition duration-300 ease-in-out">
<div className=' justify-center items-center flex pt-2'><img src="./images/accu.png" alt="" /></div>
     <h1 className='text-2xl relative pt-4   yo2 text-center text-amber-600'>ACCURACY</h1>
</div>
</div>
</div>
      </section>
      
      </div>
      <Haboutus/>
      
          <div className='mt-2 bg2' style = {{
        backgroundImage:
        `url(${bgtwo})`,
        
     }}>
 <section className='bg-blue-800/50 h-full'>

 <div className='flex  justify-center items-center	 mt-32'> <h1 className='text-white text-2xl xl:text-5xl yo2 bold uppercase text-center mt-6'>Our Clients</h1></div>
 <section className='border border-white w-28 mt-2  mx-auto  drop-shadow-md	'></section>
<div className='bg-white mt-12 xl:mt-24 max-w-80 xl:max-w-6xl h-16 xl:h-44 rounded-lg shadow-lg mx-auto'>
<CarouselLogo/>
 </div>
 </section>


            
          </div>
<div className="h-screen">
          <Reviews/>
          
          </div>

        <div className=''>
  
      </div>
      
      </>
    </div>
    
    </>
   
  )
}
